import { Box } from '@mui/material'
import { Shift } from 'models/notifications'

const SHIFT_LABELS: Record<Shift, string> = {
	am: 'Утренняя смена',
	pm: 'Дневная смена',
	night: 'Ночная смена',
} as const

interface IShiftFields {
	shift: Shift
}

export const ShiftFields = ({ shift }: IShiftFields) => {
	if (!shift) {
		return null
	}
	return (
		<Box
			component={'span'}
			sx={{
				fontSize: '14px',
				padding: '8px 8px',
				background: '#f7f7f7',
				borderRadius: '12px',
				maxWidth: 'min-content',
			}}
		>
			{SHIFT_LABELS[shift] ?? String(shift)}
		</Box>
	)
}
